<template>
  <section class="ecosystem-section">
    <div class="ecosystem-inner">

      <div class="ecosystem-part">
        <p class="ecosystem-text">
          Sportemocracy non è un singolo prodotto. È un ecosistema che unisce affiancamento tecnico,
          un network di preparatori e una piattaforma digitale per accompagnare la tua società sportiva
          in ogni fase del percorso.
        </p>
      </div>

      <div class="ecosystem-cards-block">
        <img
          class="ecosystem-logo"
          src="@/assets/sportemocracy_white.svg"
          alt="Sportemocracy"
        />
        <div class="ecosystem-connector" aria-hidden="true">
          <div class="connector-item"></div>
          <div class="connector-item"></div>
          <div class="connector-item"></div>
        </div>
        <div class="ecosystem-cards">
          <div class="ecosystem-card-wrapper">
            <div class="ecosystem-card">
              <h3 class="card-title">Affiancamento tecnico</h3>
              <p class="card-text">Servizi di affiancamento tecnico per le società sportive</p>
            </div>
            <span class="ecosystem-pill">Disponibile</span>
          </div>
          <div class="ecosystem-card-wrapper">
            <div class="ecosystem-card">
              <h3 class="card-title">Network</h3>
              <p class="card-text">Coinvolgere e formare i preparatori atletici</p>
            </div>
            <span class="ecosystem-pill">Attivo</span>
          </div>
          <div class="ecosystem-card-wrapper">
            <div class="ecosystem-card">
              <h3 class="card-title">TrainFlow</h3>
              <p class="card-text">Piattaforma digitale per la tua preparazione atletica.</p>
            </div>
            <span class="ecosystem-pill">In sviluppo</span>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'EcosystemSection'
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.ecosystem-section {
  background-color: $primary;
  color: $white;
  width: 100%;
}

.ecosystem-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.ecosystem-text {
  font-size: 1.125rem;
  line-height: 1.7;
  text-align: left;
  margin: 0;
}

.ecosystem-cards-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.ecosystem-logo {
  height: 1.5rem;
  width: auto;
  display: block;
}

.ecosystem-connector {
  display: none;
}

.ecosystem-cards {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ecosystem-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.ecosystem-card {
  width: 100%;
  background-color: $primary;
  border: 1px solid $white;
  border-radius: 25px;
  padding: 32px 24px;
}

.card-title {
  font-size: 1.5625rem;
  font-weight: 700;
  margin: 0 0 16px;
  text-align: center;
}

.card-text {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  text-align: center;
}

.ecosystem-pill {
  background-color: $white;
  color: $primary;
  font-size: 1rem;
  border-radius: 39px;
  padding: 8px 20px;
  width: 60%;
  text-align: center;
}

@media (min-width: 768px) {
  .ecosystem-inner {
    padding: 64px 40px;
  }

  .ecosystem-cards-block {
    gap: 0;
  }

  .ecosystem-logo {
    margin-bottom: 32px;
  }

  .ecosystem-connector {
    display: flex;
    width: 100%;
    height: 40px;
    gap: 32px;
  }

  .connector-item {
    flex: 1;
    position: relative;
  }

  .connector-item::before {
    content: '';
    position: absolute;
    width: 2px;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    bottom: 0;
    background-color: $white;
  }

  .connector-item::after {
    content: '';
    position: absolute;
    height: 2px;
    top: 0;
    background-color: $white;
  }

  .connector-item:first-child::after {
    left: 50%;
    right: -16px;
  }

  .connector-item:nth-child(2)::after {
    left: -16px;
    right: -16px;
  }

  .connector-item:last-child::after {
    left: -16px;
    right: 50%;
  }

  .ecosystem-cards {
    flex-direction: row;
    gap: 32px;
    align-items: stretch;
  }

  .ecosystem-card-wrapper {
    flex: 1 1 0;
    min-width: 0;
  }

  .ecosystem-card {
    flex: 1;
  }
}

@media (min-width: 1440px) {
  .ecosystem-inner {
    padding: 80px 120px;
  }

  .ecosystem-text {
    font-size: 1.25rem;
  }

  .ecosystem-logo {
    height: 2rem;
  }
}
</style>
